class ApiService {
  constructor() {
    this.baseURL = process.env.REACT_APP_API_URL || '/herding_api';
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;

    const token = localStorage.getItem('token');
    const defaultHeaders = { 'Content-Type': 'application/json' };
    if (token) {
      defaultHeaders['Authorization'] = `Bearer ${token}`;
    }

    const config = {
      headers: { ...defaultHeaders, ...options.headers },
      ...options,
    };

    const response = await fetch(url, config);
    // Parse body first — error payloads also carry JSON
    const data = await response.json().catch(() => ({}));

    if (response.status === 401) {
      // Token is missing, expired, or revoked — clear it so the app
      // knows the session is gone, and flag it so Login.js can show
      // the "session expired" message.
      localStorage.removeItem('token');
      sessionStorage.setItem('session_expired', '1');
    }

    if (!response.ok) {
      throw Object.assign(
        new Error(data.error || response.statusText),
        { status: response.status, data }
      );
    }

    return data;
  }

  async get(endpoint) {
    return this.request(endpoint, { method: 'GET' });
  }

  async post(endpoint, data) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async put(endpoint, data) {
    return this.request(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async patch(endpoint, data) {
    return this.request(endpoint, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  }

  async delete(endpoint, data) {
    const options = { method: 'DELETE' };
    if (data !== undefined) {
      options.body = JSON.stringify(data);
    }
    return this.request(endpoint, options);
  }
}

export default new ApiService();
